import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6d8415"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"150px"}
}
const _hoisted_2 = { class: "text-body-2 text-medium-emphasis mb-3" }
const _hoisted_3 = { class: "text-body-2 text-medium-emphasis mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-medium-emphasis detalle"
}

import { computed, onMounted, ref, watch } from "vue";
import { UsuarioDTO } from "@/interfaces/Usuario";
import { useUsuariosStore } from "@/store/usuarios";
import { esUsuarioBye } from "@/utils/bye";
import { codigoProvinciaDeCiudad, PROVINCIAS } from "@/utils/provincia";
import MapaUsuarios from "@/components/Mapa/MapaUsuarios.vue";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";

const POR_PAGINA = 20;


export default /*#__PURE__*/_defineComponent({
  __name: 'JugadoresView',
  setup(__props) {

const usuariosStore = useUsuariosStore();
const isLoading = ref(false);
const tab = ref("listado");
const busqueda = ref<string | null>("");
const faccion = ref<string | null>(null);
const provincia = ref<string | null>(null);
const pagina = ref(1);
const lista = ref<{ $el: HTMLElement } | null>(null);

// Ni el bye ni las cuentas borradas («Desconocido N») son jugadores
const jugadores = computed<UsuarioDTO[]>(() =>
  usuariosStore.usuarios
    .filter(u => !esUsuarioBye(u.idUsuario, u.nick) && !/^desconocido \d+$/i.test(u.nick.trim()))
    .sort((a, b) => a.nick.localeCompare(b.nick, "es", { sensitivity: "base" }))
);

// Sin tildes ni mayúsculas: «almeria» encuentra Almería
const normalizar = (texto?: string | null) =>
  (texto ?? "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

const detalle = (jugador: UsuarioDTO) =>
  [jugador.faccion?.nombreFaccion, jugador.ciudad].filter(Boolean).join(" · ");

// Solo las facciones y provincias que tienen algún jugador
const facciones = computed(() =>
  [...new Set(jugadores.value.map(j => j.faccion?.nombreFaccion).filter((f): f is string => !!f))].sort((a, b) =>
    a.localeCompare(b, "es", { sensitivity: "base" })
  )
);
const provincias = computed(() =>
  [...new Set(jugadores.value.map(j => codigoProvinciaDeCiudad(j.ciudad)).filter((c): c is string => !!c))]
    .map(codigo => ({ title: PROVINCIAS[codigo] ?? codigo, value: codigo }))
    .sort((a, b) => a.title.localeCompare(b.title, "es", { sensitivity: "base" }))
);

const hayFiltros = computed(() => !!normalizar(busqueda.value) || !!faccion.value || !!provincia.value);

const filtrados = computed(() => {
  const texto = normalizar(busqueda.value);
  return jugadores.value.filter(
    j =>
      (!faccion.value || j.faccion?.nombreFaccion === faccion.value) &&
      (!provincia.value || codigoProvinciaDeCiudad(j.ciudad) === provincia.value) &&
      (!texto ||
        normalizar(j.nick).includes(texto) ||
        normalizar(j.faccion?.nombreFaccion).includes(texto) ||
        normalizar(j.ciudad).includes(texto))
  );
});

const paginas = computed(() => Math.ceil(filtrados.value.length / POR_PAGINA));
const visibles = computed(() => filtrados.value.slice((pagina.value - 1) * POR_PAGINA, pagina.value * POR_PAGINA));

// Cada búsqueda o filtro empieza por la primera página
watch([busqueda, faccion, provincia], () => (pagina.value = 1));
// Al cambiar de página, al principio de la lista
watch(pagina, () => lista.value?.$el.scrollIntoView({ behavior: "smooth", block: "start" }));

onMounted(async () => {
  if (usuariosStore.usuarios.length) return;
  isLoading.value = true;
  try {
    await usuariosStore.requestUsuarios();
  } catch (error) {
    console.error("Error cargando usuarios:", error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_container = _resolveComponent("v-container")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingGandalf)
      ]))
    : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        class: "usuarios text-left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(jugadores.value.length) + " jugadores", 1),
          _createVNode(_component_v_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
            color: "primary",
            grow: "",
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, { value: "listado" }, {
                default: _withCtx(() => [
                  _createTextVNode("Listado")
                ]),
                _: 1
              }),
              _createVNode(_component_v_tab, { value: "mapa" }, {
                default: _withCtx(() => [
                  _createTextVNode("Mapa")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (tab.value === 'listado')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_text_field, {
                  modelValue: busqueda.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((busqueda).value = $event)),
                  placeholder: "Buscar por nick, comunidad o ciudad",
                  "prepend-inner-icon": "mdi-magnify",
                  variant: "outlined",
                  density: "compact",
                  clearable: "",
                  "hide-details": "",
                  class: "mb-2"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_row, {
                  dense: "",
                  class: "mb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          modelValue: faccion.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((faccion).value = $event)),
                          items: facciones.value,
                          label: "Facción",
                          variant: "outlined",
                          density: "compact",
                          clearable: "",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          modelValue: provincia.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((provincia).value = $event)),
                          items: provincias.value,
                          label: "Provincia",
                          variant: "outlined",
                          density: "compact",
                          clearable: "",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (filtrados.value.length === 0)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 0,
                      variant: "outlined",
                      class: "pa-4 text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(hayFiltros.value ? "Ningún jugador coincide con la búsqueda." : "Aún no hay jugadores."), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (hayFiltros.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(filtrados.value.length) + " " + _toDisplayString(filtrados.value.length === 1 ? "jugador" : "jugadores"), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_card, {
                        ref_key: "lista",
                        ref: lista,
                        variant: "outlined",
                        class: "lista"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            density: "compact",
                            "bg-color": "transparent",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (jugador, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: jugador.idUsuario
                                }, [
                                  (i > 0)
                                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'detalle-jugador', params: { idUsuario: jugador.idUsuario } },
                                    "append-icon": "mdi-chevron-right"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "font-weight-bold nick" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(jugador.nick), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (detalle(jugador))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(detalle(jugador)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ], 64))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512),
                      (paginas.value > 1)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 1,
                            modelValue: pagina.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pagina).value = $event)),
                            length: paginas.value,
                            "total-visible": 5,
                            density: "comfortable",
                            class: "mt-3"
                          }, null, 8, ["modelValue", "length"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 64))
            : (_openBlock(), _createBlock(MapaUsuarios, {
                key: 1,
                usersView: jugadores.value
              }, null, 8, ["usersView"]))
        ]),
        _: 1
      }))
}
}

})